if (!customElements.get('partners-panel')) {
  customElements.define(
    'partners-panel',
    class partnersPanel extends HTMLElement {
      constructor() {
        super();

        this.empty = this.querySelector('.empty-partners-list');

        const node = document.querySelector('.top-section');
        const offset = node.clientHeight - 60;

        this.filterPanel = this.querySelector('#partners-page-filter-panel');
        if (this.filterPanel) {
          window.addEventListener('scroll', () => {
            if (window.pageYOffset <= offset || document.documentElement.scrollTop <= offset)
              this.filterPanel.classList.remove('filter-fixed');
            else {
              this.filterPanel.classList.add('filter-fixed');
              this.filterPanel.style.top = `${this.fixedTopDistance}px`;
            }
          });
        }

        this.tabsBtns = this.querySelectorAll('.category-button');
        if (this.tabsBtns) {
          this.tabsBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
              this.activeTab = btn.dataset.target;
            });
          });
        }

        this.searchInput = this.querySelector('#search-input');
        if (this.searchInput) {
          this.searchInput.addEventListener('keyup', (e) => {
            this.searchInputMobile.value = e.target.value;
            this.filterList();
          });
        }

        this.searchInputMobile = this.querySelector('#search-input-mobile');
        if (this.searchInputMobile) {
          this.searchInputMobile.addEventListener('keyup', (e) => {
            this.filterList();
          });
        }

        if (this.tabsBtns.length > 0) {
          this._target = this.tabsBtns[0].dataset.target;
        }
      }

      set activeTab(target) {
        this.tabsBtns.forEach((btn) => {
          if (btn.dataset.target == target) {
            btn.classList.remove('button-transparent');
          } else btn.classList.add('button-transparent');
        });

        this._target = target;

        this.filterList();
      }

      get list() {
        return this.querySelectorAll('.partner-item');
      }

      get hiddenItems() {
        return this.querySelectorAll('.partner-item.hidden');
      }

      get fixedTopDistance() {
        return document.querySelector('.app-banner') ? 130 : 130;
      }

      get search() {
        return this.searchInput.value || this.searchInputMobile.value;
      }

      filterList() {
        const query = this.search.toLowerCase().trim();
        const target = this._target;
        this.list.forEach((item) => {
          const partnerTitle = item.querySelector('.partner-title');
          const partnerPreamble = item.querySelector('.partner-preamble');
          const partnerDescription = item.querySelector('.partner-description');

          let title = '';
          if (partnerTitle) {
            title = partnerTitle.textContent.toLowerCase();
          }

          let preamble = '';
          if (partnerPreamble) {
            preamble = partnerPreamble.textContent.toLowerCase();
          }

          let description = '';
          if (partnerDescription) {
            description = partnerDescription.textContent.toLowerCase();
          }

          let is_search = false,
            is_category = false;

          if (title.includes(query) || preamble.includes(query) || description.includes(query)) is_search = true;
          else is_search = false;

          if (target.includes('all') || item.dataset.target == target) {
            is_category = true;
          } else is_category = false;

          if (is_search && is_category) item.classList.remove('hidden');
          else item.classList.add('hidden');
        });

        if (this.hiddenItems.length == this.list.length) this.empty.classList.remove('hidden');
        else this.empty.classList.add('hidden');
      }
    },
  );
}
